<template>
  <button
    ref="scrollToTop"
    class="scroll-to-top"
    type="button"
    @click="onScrollToTop"
  >
    <span class="scroll-to-top__label">{{ $t('Scroll to top') }}</span>
    <IconArrow class="scroll-to-top__icon icon icon--arrow-top" />
  </button>
</template>

<script lang="ts" setup>
const scrollToTop = ref(null)

function onScroll() {
  if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
    scrollToTop.value?.classList.add('scroll-to-top--show')
  }
  else {
    scrollToTop.value?.classList.remove('scroll-to-top--show')
  }
}

function onScrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

onMounted(() => {
  window.addEventListener('scroll', onScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', onScroll)
})

// export default {
//   components: {
//     iconArrow
//   },
//   mounted () {
//     window.addEventListener('scroll', this.onScroll)
//   },
//   methods: {
//     onScroll () {
//       if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
//         this.$refs.scrollToTop.classList.add('scroll-to-top--show')
//       } else {
//         this.$refs.scrollToTop.classList.remove('scroll-to-top--show')
//       }
//     },
//     scrollToTop () {
//       window.scrollTo({ top: 0, behavior: 'smooth' })
//     }
//   }
// }
</script>

<style>
@import url("~layers/app/components/Ui/ScrollToTop.css");
</style>
